import { v4 as uuidv4 } from "uuid";
import { makeObservable, observable, action } from "mobx";
import CellStore from "./cell";
// MobX Store
class RowStore {
  id;
  cells = new Map();
  orderBy = -1;
  constructor(columns = [], id = uuidv4(), rowsList = []) {
    this.id = id;
    columns.forEach((columnId) => {
      this.cells.set(columnId, new CellStore({ value: "" })); // Initialize with empty value
    });
    makeObservable(this, {
      cells: observable,
      setCell: action,
      addCell: action,
    });
  }
  setOrderBy(value) {
    this.orderBy = value;
  }
  setCell(columnId, value) {
    if (this.cells.has(columnId)) {
      this.cells.get(columnId).setValue(value);
    }
  }
  setCellObj(columnId, value) {
    if (this.cells.has(columnId)) {
      this.cells.get(columnId).setObjValue(value);
    }
  }
  addCell(columnId) {
    if (!this.cells.has(columnId)) {
      this.cells.set(columnId, new CellStore(""));
    }
  }
  getCell() {
    return this.cells;
  }
  getCellValue(columnId) {
    return this.cells.has(columnId) ? this.cells.get(columnId).value : "";
  }
  getCellObj(columnId) {
    return this.cells.has(columnId) ? this.cells.get(columnId) : null;
  }
  deleteCell(columnId) {
    if (this.cells.has(columnId)) {
      this.cells.delete(columnId);
    }
  }
}
export default RowStore;
